module.exports = __webpack_public_path__ + "img/status0_icon.0422c332.png";